import React from 'react';
import { ExternalLink } from 'lucide-react';
export function ResourceLinks() {
  const links = [{
    name: 'Federal Motor Carrier Safety Administration',
    url: 'www.fmcsa.dot.gov'
  }, {
    name: 'National Highway Traffic Safety Administration',
    url: 'www.nhtsa.dot.gov'
  }, {
    name: 'U.S. Department of Transportation (U.S. DOT)',
    url: 'www.dot.gov'
  }, {
    name: "FMCSA's Safety and Fitness Electronic Record System (SAFER)",
    url: 'www.safersys.org'
  }];
  return <section className="py-16 bg-white border-t border-legal-border" data-id="element-184">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="bg-legal-light rounded-lg p-8 md:p-10 border border-legal-border shadow-sm" data-id="element-186">
          <h3 className="text-2xl font-bold text-legal-dark mb-6 flex items-center" data-id="element-187">
            WEBSITES:
          </h3>
          <ul className="space-y-4" data-id="element-188">
            {links.map((link, idx) => <li key={idx} className="flex items-start" data-id="element-189">
                <ExternalLink className="w-5 h-5 text-legal-red mr-3 flex-shrink-0 mt-0.5" data-id="element-190" />
                <div data-id="element-191">
                  <span className="block font-medium text-legal-dark" data-id="element-192">
                    {link.name}
                  </span>
                  <a href={`http://${link.url}`} className="text-blue-600 hover:underline text-sm break-all" target="_blank" rel="noopener noreferrer" data-id="element-193">
                    {link.url}
                  </a>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}